import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {closeDialog} from '../../slices/dialog';
import ClipLoader from "react-spinners/ClipLoader";
import {deleteFollow} from '../../api/follow';
import {openAlert} from '../../slices/alert';
import {resetSelectedCompany, resetSelectedRm, selectSelectedRm} from '../../slices/selected';
import {useHistory} from 'react-router';
import {analyticsEvents, ROUTES} from '../../db/models/const';
import {useTranslation} from 'react-i18next';

export const LeaveRm = () => {
    const [loading, setLoading] = useState(false);
    const [checkbox, setCheckbox] = useState(false);
    const dispatch = useDispatch();
    const rm = useSelector(selectSelectedRm);
    const history = useHistory();
    const {t} = useTranslation();

    const onSubmit = () => {
        setLoading(true);

        dispatch(openAlert({type: "info", message: t("alert_wait")}));

        deleteFollow(rm.id, rm.companyId, !checkbox)
            .then(() => {
                dispatch(resetSelectedRm());
                dispatch(resetSelectedCompany());
                setLoading(false);
                dispatch(closeDialog());
                dispatch(openAlert({type: "info", message: t("alert_rm_left")}));
                history.push(ROUTES.ME);
            })
            .catch(error => {
                setLoading(false);
                dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
            });
    }

    const onDiscard = () => {
        dispatch(closeDialog());
    }

    return (
        <div className="leaveRm">
            {!loading && <>
                <p className="text">
                    {t("student_leaveRm_text")}
                </p>
                <div className="checkbox">
                    <input type="checkbox" value={checkbox} onChange={() => setCheckbox(!checkbox)}/>
                    <p>{t("student_leaveRm_checkbox")}</p>
                </div>
                <div className="actions">
                    <button className="discard" onClick={() => onDiscard()}>{t("student_leaveRm_cancelBtn")}</button>
                    <button className="leave" onClick={() => onSubmit()}>{t("student_leaveRm_leaveBtn")}</button>
                </div>
            </>}
            {loading && <ClipLoader size={20} color={"#7400b8"} loading={true}/>}
        </div>
    )
}
